import React from "react";
import CcButton from "../../CoilConfigurator/components/CcButton";
import WarningBanner from "../components/WarningBanner";
import OpStatusPill from "../components/OpStatusPill";
import BlastFrameCard from "../equipment/blast-frame/BlastFrameCard";
import InductionCoilCard from "../equipment/induction-coil/InductionCoilCard";
import InputSpecificationSummary from "../components/InputSpecificationSummary";
import type { ConfigurationResult, EquipmentKind } from "../models/types";

interface ConfigurationResultViewProps {
  result: ConfigurationResult;
  onBackToList: () => void;
  onViewEquipment: (kind: EquipmentKind) => void;
  onOpenBuildSpec: (kind: EquipmentKind) => void;
}

const ConfigurationResultView = ({
  result,
  onBackToList,
  onViewEquipment,
  onOpenBuildSpec,
}: ConfigurationResultViewProps) => (
  <div className="op-result">
    <div className="op-result__header">
      <div>
        <p className="op-kicker">Configuration Result</p>
        <h2 className="op-section-title">
          {result.project.projectNumber} · {result.configurationId}
        </h2>
        <p className="op-muted">Revision {result.revision}</p>
      </div>
      <div className="op-result__actions">
        <OpStatusPill status={result.status} />
        <CcButton variant="secondary" onClick={onBackToList}>
          All configurations
        </CcButton>
      </div>
    </div>

    <div className="op-result__status">
      {result.warnings.map((warning) => (
        <WarningBanner key={`${warning.title}-${warning.message}`} warning={warning} />
      ))}
    </div>

    <InputSpecificationSummary
      project={result.project}
      pipe={result.pipe}
      process={result.process}
    />

    {result.errorMessage ? (
      <p className="op-field-error" role="alert">
        {result.errorMessage}
      </p>
    ) : (
      <div className="op-equip-grid">
        {result.blastFrame ? (
          <div>
            <BlastFrameCard
              equipment={result.blastFrame}
              onViewDetails={() => onViewEquipment("blast-frame")}
            />
            <CcButton
              variant="link"
              onClick={() => onOpenBuildSpec("blast-frame")}
              className="op-build-link"
            >
              Build specification
            </CcButton>
          </div>
        ) : null}
        {result.inductionCoil ? (
          <div>
            <InductionCoilCard
              equipment={result.inductionCoil}
              onViewDetails={() => onViewEquipment("induction-coil")}
            />
            <CcButton
              variant="link"
              onClick={() => onOpenBuildSpec("induction-coil")}
              className="op-build-link"
            >
              Build specification
            </CcButton>
          </div>
        ) : null}
      </div>
    )}
  </div>
);

export default ConfigurationResultView;
